import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLBackgroundServiceClient } from "./api/cplapi/CPLAPI";

export interface IBackgroundServiceService {
  notifyAllActiveProcesses(): Promise<void>;
  acknowledge(processID: number): Promise<void>;
}

@injectable()
export class BackgroundServiceService implements IBackgroundServiceService {
  @inject(SERVICE_TYPES.CPLBackgroundServiceClient) cplBackgroundServiceClient!: ICPLBackgroundServiceClient;

  async notifyAllActiveProcesses(): Promise<void> {
    await this.cplBackgroundServiceClient.notifyAllActiveProcesses();
  }

  acknowledge(processID: number): Promise<void> {
    return this.cplBackgroundServiceClient.acknowledge(processID);
  }
}
